import { render, staticRenderFns } from "./specimenTable.vue?vue&type=template&id=5e5e255e&scoped=true&"
import script from "./specimenTable.vue?vue&type=script&lang=js&"
export * from "./specimenTable.vue?vue&type=script&lang=js&"
import style0 from "./specimenTable.vue?vue&type=style&index=0&id=5e5e255e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e5e255e",
  null
  
)

export default component.exports